const Settings = Object.freeze({
  altShiftDragRotate: 'altShiftDragRotate',
  alwaysNewLayers: 'alwaysNewLayers',
  copyCoordinatesOnClick: 'copyCoordinatesOnClick',
  dragPan: 'dragPan',
  keyboardPan: 'keyboardPan',
  keyboardZoom: 'keyboardZoom',
  mouseOnlyToEditVectorShapes: 'mouseOnlyToEditVectorShapes',
  mouseWheelZoom: 'mouseWheelZoom',
  selectVectorMapShapes: 'selectVectorMapShapes',
  snapHelpLines: 'snapHelpLines',
  snapInteraction: 'snapInteraction',
  updateToolboxCoordinatesOnHover: 'updateToolboxCoordinatesOnHover',
});

export { Settings };
